import Vue from 'vue';
import Vuex from 'vuex';

import { HearroVue } from '@/store/hearoPlugin'

Vue.use(Vuex);

const userPlugin = store => {
  store.commit('hearro/init')
}

export default new Vuex.Store({
  plugins: [userPlugin],
  state: {},
  mutations: {},
  actions: {},
  modules: {
    hearro: HearroVue
  }
});
